'use client';
var classes = {"root":"m_87cf2631"};

export { classes as default };
//# sourceMappingURL=UnstyledButton.module.css.mjs.map
